import { ReloadPage } from './ReloadPage';

export * from './ErrorBoundary';

export const ErrorBoundaries = {
  ReloadPage,
};
